module.exports = __webpack_public_path__ + "img/Games.5c0d8f95.jpg";